export default "__VITE_ASSET__Vgi_q6hF__"